import { ToastProvider } from "@/ds";

import { LoginScreenLigada } from "./login-screen";

/** Monta o `ToastProvider` da tela de login; o feedback de erro e de saída vem de `useToast()` no conteúdo. */
export function LoginScreen() {
  return (
    <ToastProvider position="top-right">
      <LoginScreenLigada />
    </ToastProvider>
  );
}
